import { useState, useEffect, useCallback } from "react";
import { reviewsApi } from "@/api/social";

export function useCompanyRating(companyId: string | undefined) {
  const [rating, setRating] = useState<number | undefined>();
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(false);

  const load = useCallback(async () => {
    if (!companyId) return;
    setLoading(true);
    try {
      const res = await reviewsApi.list(companyId);
      setRating(res.averageRating);
      setCount(res.totalReviews || (res.reviews || []).length);
    } catch {
      // ignore
    } finally {
      setLoading(false);
    }
  }, [companyId]);

  useEffect(() => {
    load();
  }, [load]);

  return { rating, count, loading };
}

export function RatingBadge({ companyId }: { companyId: string }) {
  const { rating, count, loading } = useCompanyRating(companyId);

  if (loading || rating === undefined || count === 0) return null;

  return (
    <span className="inline-flex items-center gap-1 rounded-full bg-yellow-500/10 px-2 py-0.5 text-[11px] font-medium text-yellow-600 dark:text-yellow-400">
      ★ {rating.toFixed(1)} ({count})
    </span>
  );
}
